<template>
  <div class="contentPadding">
    <a-tabs v-model:activeKey="activeKey" :animated="false">
      <a-tab-pane key="1" tab="考试场次列表">
          <appointment></appointment>
      </a-tab-pane>
      <a-tab-pane key="2" tab="报考考试信息" force-render>
        <sign-up></sign-up>
      </a-tab-pane>
      <a-tab-pane key="3" tab="确认考试信息">
          <confirm></confirm>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import appointment from './appointment'
import signUp from './signUp'
import confirm from './confirm'
export default {
  data() {
    return {
      activeKey: "1"
    };
  },
  components:{
      appointment,
      signUp,
      confirm
  }
};
</script>
